(function() {
    'use strict';

    angular.module('app').filter('searchFilterWithKey', function() {

        return function(input, search, key) {
            if (!input){return null;}
            if (!search){return null;}
            if (!key){return null;}
            let results = {};
            angular.forEach(input,function(obj){
                if(obj[key].toLowerCase().indexOf( search.toLowerCase() ) > -1) {
                    results[obj.id] = true;
                }
            });
            return results;
        };
    });

}());